<header>
  <h2
    class="dialog-title"
    mat-dialog-title
    [attr.data-test]="dataTest + '-title'"
  >
    {{ data.title }}
  </h2>
</header>

<section class="dialog-content" mat-dialog-content>
  <p [attr.data-test]="dataTest + '-content'">
    {{ data.content ?? defaultContent }}
  </p>

  <p class="mat-subtitle-2 bold dialog-subtitle" i18n>Processing</p>

  <mat-progress-bar
    [mode]="
      data.progress && data.progress.total > 0 ? 'determinate' : 'indeterminate'
    "
    [attr.data-test]="dataTest + '-progress-bar'"
    [value]="
      data.progress ? (data.progress.current / data.progress.total) * 100 : 0
    "
  ></mat-progress-bar>

  <p
    *ngIf="data.progress && data.progress.total > 0"
    class="mat-body-2"
    [attr.data-test]="dataTest + '-progress-counter'"
    i18n
  >
    <span
      class="bold"
      [attr.data-test]="dataTest + '-progress-counter-current'"
      >{{ data.progress.current }}</span
    >
    of
    <span [attr.data-test]="dataTest + '-progress-counter-total'">{{
      data.progress.total
    }}</span>
    processed
  </p>
</section>
